import React, { ReactNode } from "react";
import classNames from "lib/classNames";
import Container from "hardcover-ui/components/Container";
import { ImageSerializersImage } from "types/serializers";

interface CoverLayoutProps {
  children: ReactNode;
  cover: ImageSerializersImage;
}

export default function CoverLayout({ children, cover }: CoverLayoutProps) {
  return (
    <div className="relative -mt-[64px] pt-[64px]">
      <div
        className="absolute top-0 left-0 w-full md:h-[350px] h-[150px] bg-cover bg-center opacity-60 fade-bottom-sm"
        style={{
          backgroundImage: `url('${cover.url}')`,
        }}
      >
        <div
          className={classNames(
            "bg-linear-to-b from-transparent to-background h-full flex flex-col justify-end items-center",
            "lg:from-50% lg:to-100%",
            "to-80%"
          )}
        />
      </div>

      {/* Content Container */}
      <Container
        size="lg"
        variant="layout"
        className="relative mt-4 sm:mt-10 xl:mt-14 2xl:mt-20 md:bg-white/70 md:dark:bg-gray-800/70 backdrop-blur-md rounded-t-3xl border-t border-secondary transition-all duration-200 ease-in-out"
      >
        {children}
      </Container>
    </div>
  );
}
